document.addEventListener("DOMContentLoaded", function () {
    const santaOption = document.getElementById("santa-option");

    // Function to check cart total
    async function updateSantaOption() {
        try {
            const response = await fetch('/cart.js'); 
            const cart = await response.json();
            
            if (cart.total_price > 300000) {
                santaOption.style.display = "block"; 
            } else {
                santaOption.style.display = "none"; 
            }
        } catch (error) {
            console.error("Error fetching cart details:", error);
        }
    }

    updateSantaOption();

    setInterval(updateSantaOption, 3000);
});


document.addEventListener("DOMContentLoaded", function () {
    const santaOptionss = document.getElementById("santa-optionss");

    // Function to check cart total
    async function updateSantaOption() {
        try {
            const response = await fetch('/cart.js'); 
            const cart = await response.json();
            
            if (cart.total_price < 300000) {
                santaOptionss.style.display = "block"; 
            } else {
                santaOptionss.style.display = "none"; 
            }
        } catch (error) {
            console.error("Error fetching cart details:", error);
        }
    }

    updateSantaOption();

    setInterval(updateSantaOption, 3000);
});
